export default function useVideo(dom: any) {
    const domparser = new DOMParser();
    let doc = domparser.parseFromString(dom, "text/html");
    const videoDOMs = doc.querySelectorAll('[data-menu-action="insert.video"]');
    if (videoDOMs.length > 0) {
        return '<script src="https://ptxpublicres.ptengine.jp/scripts/video/useVideo.js"></script>'
    }
}